var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-table",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.loading,
          expression: "loading",
        },
      ],
      ref: "evalTable",
      staticClass: "sk-table",
      staticStyle: { width: "100%" },
      attrs: { data: _vm.data, border: true },
      on: { "selection-change": _vm.handleSelectionChange },
    },
    [
      _c("el-table-column", {
        attrs: { type: "selection", width: "45", align: "center" },
      }),
      _c("el-table-column", {
        attrs: { label: "STT", type: "index", width: "50", align: "center" },
      }),
      _c("el-table-column", {
        attrs: {
          label: "Tên học sinh",
          prop: "studentName",
          "min-width": "160",
        },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function ({ row }) {
              return [
                _c("span", { staticClass: "evl-student-name" }, [
                  _vm._v(_vm._s(row.studentName)),
                ]),
              ]
            },
          },
        ]),
      }),
      _c("el-table-column", {
        attrs: { label: "Ngày tạo", width: "150", align: "center" },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function ({ row }) {
              return [
                row.evaluations && row.evaluations.length > 0
                  ? _vm._l(row.evaluations, function (evaluation) {
                      return _c(
                        "div",
                        {
                          key: evaluation.uid + "_date",
                          staticClass: "evl-date-cell",
                        },
                        [
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm._f("formatDateTime")(evaluation.createdDate)
                              )
                            ),
                          ]),
                        ]
                      )
                    })
                  : _c("span", { staticClass: "text-slate-400" }, [
                      _vm._v("—"),
                    ]),
              ]
            },
          },
        ]),
      }),
      _c("el-table-column", {
        attrs: { label: "Duyệt", width: "100", align: "center" },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function ({ row }) {
              return [
                row.evaluations && row.evaluations.length > 0
                  ? [
                      _c(
                        "el-tag",
                        {
                          attrs: {
                            size: "mini",
                            type:
                              _vm.getApprovalStatus(row) === "APPROVED"
                                ? "success"
                                : "info",
                          },
                        },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(
                                _vm.getApprovalStatus(row) === "APPROVED"
                                  ? "Đã duyệt"
                                  : "Chờ duyệt"
                              ) +
                              "\n          "
                          ),
                        ]
                      ),
                    ]
                  : _c("span", { staticClass: "text-slate-400" }, [
                      _vm._v("—"),
                    ]),
              ]
            },
          },
        ]),
      }),
      _c("el-table-column", {
        attrs: { label: "Nhận xét", "min-width": "300" },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function ({ row }) {
              return [
                row.evaluations && row.evaluations.length > 0
                  ? _c(
                      "div",
                      _vm._l(row.evaluations, function (evaluation, idx) {
                        return _c(
                          "div",
                          {
                            key: evaluation.uid,
                            staticClass: "evl-evaluation-item",
                            class: { "evl-evaluation-item--border": idx > 0 },
                          },
                          [
                            evaluation.items && evaluation.items.length > 0
                              ? [
                                  _c(
                                    "div",
                                    { staticClass: "evl-item-tags" },
                                    _vm._l(evaluation.items, function (item) {
                                      return _c(
                                        "el-tag",
                                        {
                                          key: item.categoryId,
                                          staticStyle: { margin: "2px" },
                                          attrs: { size: "mini" },
                                        },
                                        [
                                          _vm._v(
                                            "\n                  " +
                                              _vm._s(item.categoryName) +
                                              "\n                "
                                          ),
                                        ]
                                      )
                                    }),
                                    1
                                  ),
                                ]
                              : [
                                  _c(
                                    "div",
                                    {
                                      class: [
                                        "evl-eval-content",
                                        {
                                          expanded: _vm.isExpanded(
                                            row.studentId,
                                            evaluation.uid
                                          ),
                                        },
                                      ],
                                    },
                                    [
                                      _c("span", [
                                        _vm._v(_vm._s(evaluation.content)),
                                      ]),
                                    ]
                                  ),
                                  _vm.showToggle(evaluation.content)
                                    ? _c(
                                        "div",
                                        { staticClass: "evl-desc-toggle" },
                                        [
                                          _c(
                                            "a",
                                            {
                                              attrs: { href: "#" },
                                              on: {
                                                click: function ($event) {
                                                  $event.preventDefault()
                                                  return _vm.toggleExpand(
                                                    row.studentId,
                                                    evaluation.uid
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _vm._v(
                                                "\n                  " +
                                                  _vm._s(
                                                    _vm.isExpanded(
                                                      row.studentId,
                                                      evaluation.uid
                                                    )
                                                      ? "Thu gọn"
                                                      : "Xem thêm"
                                                  ) +
                                                  "\n                "
                                              ),
                                            ]
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                ],
                          ],
                          2
                        )
                      }),
                      0
                    )
                  : _c("span", { staticClass: "text-slate-400" }, [
                      _vm._v("—"),
                    ]),
              ]
            },
          },
        ]),
      }),
      _c("el-table-column", {
        attrs: { label: "File", width: "80", align: "center" },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function ({ row }) {
              return [
                row.evaluations && row.evaluations.length > 0
                  ? _vm._l(row.evaluations, function (evaluation) {
                      return _c(
                        "div",
                        {
                          key: evaluation.uid + "_files",
                          staticClass: "evl-file-cell",
                        },
                        [
                          _vm.getFileCount(evaluation) > 0
                            ? _c("span", { staticClass: "evl-file-count" }, [
                                _c(
                                  "a",
                                  {
                                    attrs: { href: "#" },
                                    on: {
                                      click: function ($event) {
                                        $event.preventDefault()
                                        return _vm.$emit(
                                          "view-files",
                                          evaluation.files
                                        )
                                      },
                                    },
                                  },
                                  [
                                    _c("i", {
                                      staticClass: "el-icon-paperclip",
                                    }),
                                    _vm._v(
                                      " " +
                                        _vm._s(_vm.getFileCount(evaluation)) +
                                        "\n              "
                                    ),
                                  ]
                                ),
                              ])
                            : _c("span", { staticClass: "text-slate-400" }, [
                                _vm._v("—"),
                              ]),
                        ]
                      )
                    })
                  : _c("span", { staticClass: "text-slate-400" }, [
                      _vm._v("—"),
                    ]),
              ]
            },
          },
        ]),
      }),
      _c("el-table-column", {
        attrs: { label: "Phản hồi", width: "100", align: "center" },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function ({ row }) {
              return [
                row.evaluations && row.evaluations.length > 0
                  ? [
                      _c(
                        "span",
                        {
                          staticClass: "evl-reply-badge",
                          class: {
                            "evl-reply-badge--active":
                              _vm.getTotalReplies(row) > 0,
                          },
                        },
                        [
                          _c("i", { staticClass: "el-icon-chat-dot-round" }),
                          _vm._v(
                            " " +
                              _vm._s(_vm.getTotalReplies(row)) +
                              "\n          "
                          ),
                        ]
                      ),
                    ]
                  : _c("span", { staticClass: "text-slate-400" }, [
                      _vm._v("—"),
                    ]),
              ]
            },
          },
        ]),
      }),
      _c("el-table-column", {
        attrs: {
          label: "Thao tác",
          width: "230",
          align: "center",
          fixed: "right",
        },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function ({ row }) {
              return [
                row.evaluations && row.evaluations.length > 0
                  ? _c(
                      "div",
                      { staticClass: "flex flex-wrap justify-center gap-1" },
                      [
                        _c(
                          "el-tooltip",
                          {
                            attrs: {
                              content: "Xem chi tiết",
                              placement: "top",
                            },
                          },
                          [
                            _c("el-button", {
                              attrs: {
                                type: "primary",
                                icon: "el-icon-view",
                                size: "mini",
                                circle: "",
                                plain: "",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.$emit("view", row)
                                },
                              },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "el-tooltip",
                          { attrs: { content: "Chỉnh sửa", placement: "top" } },
                          [
                            _c("el-button", {
                              attrs: {
                                type: "primary",
                                icon: "el-icon-edit",
                                size: "mini",
                                circle: "",
                                plain: "",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.handleEditFirst(row)
                                },
                              },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "el-tooltip",
                          { attrs: { content: "Duyệt", placement: "top" } },
                          [
                            _c("el-button", {
                              attrs: {
                                type: "success",
                                icon: "el-icon-check",
                                size: "mini",
                                circle: "",
                                plain: "",
                                disabled:
                                  _vm.getApprovalStatus(row) === "APPROVED",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.handleApproveFirst(row)
                                },
                              },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "el-tooltip",
                          { attrs: { content: "Lịch sử", placement: "top" } },
                          [
                            _c("el-button", {
                              attrs: {
                                type: "info",
                                icon: "el-icon-time",
                                size: "mini",
                                circle: "",
                                plain: "",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.handleActivityLog(row)
                                },
                              },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "el-tooltip",
                          { attrs: { content: "Xóa", placement: "top" } },
                          [
                            _c("el-button", {
                              attrs: {
                                type: "danger",
                                icon: "el-icon-delete",
                                size: "mini",
                                circle: "",
                                plain: "",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.handleDeleteFirst(row)
                                },
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    )
                  : _c(
                      "div",
                      { staticClass: "flex flex-wrap justify-center gap-1" },
                      [
                        _c(
                          "el-tooltip",
                          {
                            attrs: {
                              content: "Thêm nhận xét",
                              placement: "top",
                            },
                          },
                          [
                            _c("el-button", {
                              attrs: {
                                type: "primary",
                                icon: "el-icon-plus",
                                size: "mini",
                                circle: "",
                                plain: "",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.$emit("add-for-student", row)
                                },
                              },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "el-tooltip",
                          { attrs: { content: "Lịch sử", placement: "top" } },
                          [
                            _c("el-button", {
                              attrs: {
                                type: "info",
                                icon: "el-icon-time",
                                size: "mini",
                                circle: "",
                                plain: "",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.handleActivityLog(row)
                                },
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
              ]
            },
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }